import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var EditDesktopSvg = function EditDesktopSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2.004 9.556.004 5.556 3.74.004 3.739.004v1.888h-3.23V18h7.486v-.992H10.53V15.12H18v-3.984h-1.044v2.976H3.044V5.008L6.5 5.004 9.96 5l.004-.5.004-.5H2z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m16.778 2.293 2.93 2.93-6.279 6.277H10.5V8.57zm0 1.414L11.5 8.985V10.5h1.515l5.278-5.278z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m17.5 7.207-2.5-2.5.707-.707 2.5 2.5z",
    clipRule: "evenodd"
  }));
};
export var EditDesktop = function EditDesktop(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: EditDesktopSvg
  }));
};